import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StockService } from 'src/app/services/stock.service';
import { ToastService } from 'src/app/services/toast.service';
import { SignalingTypeEnum, VerticalGroupTypeEnum, VerticalSignalingEnum } from 'src/enumerators';
import { Contract, ContractVerticalItemSupport, SupportTaskActivities, Task } from 'src/models';

@Component({
  selector: 'app-support-activity',
  templateUrl: './support-activity.component.html',
  styleUrls: ['../forms-styles.css'],
})
export class SupportActivityComponent implements OnInit {
  stockEntries: any[] = [];
  supportItems: ContractVerticalItemSupport[] = [];
  radioState = [];

  lastQuantity: number;
  quantityToBeRegistered: number;
  modalsRef?: Array<BsModalRef> = [];
  currentItem: SupportTaskActivities;
  verticalSignEnum = VerticalSignalingEnum;
  typeSignEnum = SignalingTypeEnum; // Enum do tipo HVD

  @Input() supportTaskActivities: any[];
  @Input() contract: Contract;
  @Output() validationEvent = new EventEmitter<boolean>();
  @Output() removeActivityEvent = new EventEmitter<any>();
  @Input() task: Task;
  @Input() isStock: boolean = false;

  constructor(
    private _toastService: ToastService,
    private _stockService: StockService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    this.contract?.verticalGroups.forEach((group) => {
      if (group.groupType == VerticalGroupTypeEnum.Support) {
        group.verticalItems.forEach((item: ContractVerticalItemSupport) => {
          this.supportItems.push(item);
        });
      }
    });
    this.supportTaskActivities.forEach((sign) => {
      this.radioState.push(sign.stockedSupportId ? { contract: false, stock: true } : { contract: true, stock: false });
      if (sign?.contractVerticalItemId) {
        this.setContractItem(sign);
      }
      if (sign.id) {
        this.lastQuantity = sign.quantity;
      }
      sign['quantityToBeRegistered'] = sign.quantity;
    });

    this._stockService.getStockedSupport(this.contract.id).subscribe((res: any) => {
      this.stockEntries = res;
    });
  }

  verifyQuantity(index) {
    if (this.supportTaskActivities[index].id && this.isStock) {
      if (this.supportTaskActivities[index]?.quantityToBeRegistered >= this.lastQuantity) {
        this.supportTaskActivities[index].quantity = this.supportTaskActivities[index]?.quantityToBeRegistered;
      } else {
        this.supportTaskActivities[index].quantityToBeRegistered = this.lastQuantity;
        this._toastService.showError('A quantidade não pode ser inferior às cadastradas.');
      }
    } else if (this.supportTaskActivities[index]?.id) {
      if (this.supportTaskActivities[index]?.quantityToBeRegistered >= this.supportTaskActivities[index]?.quantityRegistered) {
        this.supportTaskActivities[index].quantity = this.supportTaskActivities[index]?.quantityToBeRegistered;
      } else {
        this.supportTaskActivities[index].quantityToBeRegistered = this.supportTaskActivities[index]?.quantityRegistered;
        this._toastService.showError('A quantidade não pode ser inferior às cadastradas.');
      }
    }
    else {
      this.supportTaskActivities[index].quantity = this.supportTaskActivities[index]?.quantityToBeRegistered;
    }
  }

  // Defini o item do contrato para autocomplete e calculo
  setContractItem(sign: SupportTaskActivities, stockedId?, index?) {
    var item: any;
    if (!stockedId) {
      item = this.supportItems.find((item) => item.id == sign?.contractVerticalItemId);
      if (item.adjustedUnitValue) item.unitValue = item.adjustedUnitValue;
      sign.contractVerticalItem = item;
      if (sign.quantity) this.setCost(sign);
    } else {
      item = this.stockEntries.find((item) => item.id == stockedId).contractVerticalItem;
      this.supportTaskActivities[index].contractVerticalItem = item;
      this.supportTaskActivities[index].contractVerticalItemId = item.id;
      this.supportTaskActivities[index].stockedSupportId = stockedId;
      this.setCost(this.supportTaskActivities[index]);
    }
  }

  // Atribui valor à sinalização
  setCost(sign: SupportTaskActivities) {
    sign.cost = sign.quantity * (sign?.contractVerticalItem?.unitValue ?? 0);
  }

  // Remove a atividade
  removeActivity(index: number) {
    this.supportTaskActivities.splice(index, 1);
    this.removeActivityEvent.emit(index);
  }

  // Emite validação do form
  emitValidation(support: any) {
    const validation = support?.contractVerticalItem?.supportMaterial && support.quantity > 0;
    this.validationEvent.emit(validation);
  }

  setBond(type, index) {
    if (type == 'stock') {
      this.radioState[index] = { stock: true, contract: false };
    } else {
      this.radioState[index] = { stock: false, contract: true };
    }
  }

  // Método chamado após selecionar a sinalização dentro do modal
  selectSignModal(event) {
    this.currentItem.verticalCode = event[0];
  }

  closeModal() {
    const last: any = this.modalsRef.length - 1;
    this.modalsRef[last].hide();
    this.modalsRef.pop();
  }

  // Abre MODAL
  openModalXL(template: TemplateRef<any>) {
    const modalRefAux: BsModalRef = this._modalService.show(template, {
      class: 'modal-dialog-centered modal-xl',
      backdrop: 'static',
    });
    this.modalsRef.push(modalRefAux);
  }

}
